import type {
	OptimizationGroupCreateModel,
	OptimizationGroupModel,
	UpdateOptimizationGroupRequestModel,
} from '@/shared/generated'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { useMutation } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export function useCreateOptimizationGroupMutation(
	options?: UseMutationOptions<
		OptimizationGroupModel,
		AxiosError,
		OptimizationGroupCreateModel
	>
) {
	return useMutation<
		OptimizationGroupModel,
		AxiosError,
		OptimizationGroupCreateModel
	>({
		mutationFn: (data) =>
			client.optimizationGroups.createOptimizationGroup(data),
		...(options || {}),
	})
}
export function useDeleteOptimizationGroupMutation(
	options?: UseMutationOptions<void, AxiosError, string>
) {
	return useMutation<void, AxiosError, string>({
		mutationFn: (optimizationGroupId) =>
			client.optimizationGroups.deleteOptimizationGroup({
				optimizationGroupId,
			}),
		...(options || {}),
	})
}
export function useUpdateOptimizationGroupMutation(
	optimizationGroupId: string,
	options?: UseMutationOptions<
		OptimizationGroupModel,
		AxiosError,
		UpdateOptimizationGroupRequestModel
	>
) {
	return useMutation<
		OptimizationGroupModel,
		AxiosError,
		UpdateOptimizationGroupRequestModel
	>({
		mutationFn: (data) =>
			client.optimizationGroups.updateOptimizationGroup(
				{ optimizationGroupId },
				data
			),
		...(options || {}),
	})
}
